export interface Swatch {
  color: string;
  bg: string;
  text: string;
}

export const SWATCHES: Swatch[] = [
  { color: "#14B8A6", bg: "#CCFBF1", text: "#0D6B63" },
  { color: "#3B82F6", bg: "#DBEAFE", text: "#1E40AF" },
  { color: "#8B5CF6", bg: "#EDE4FE", text: "#5B3BA8" },
  { color: "#EC4899", bg: "#FCE7F3", text: "#9D1D5C" },
  { color: "#F97066", bg: "#FEE4E2", text: "#8B1C12" },
  { color: "#F59E0B", bg: "#FEF3C7", text: "#92540C" },
  { color: "#10B981", bg: "#D1FAE5", text: "#065F46" },
  { color: "#0EA5E9", bg: "#E0F2FE", text: "#075985" },
  { color: "#6366F1", bg: "#E0E7FF", text: "#3730A3" },
  { color: "#64748B", bg: "#E2E8F0", text: "#334155" },
];
